import { api } from '@/api/client';
import type { Event } from '@mr-website/schemas';

export async function cancelRsvp(eventId: string): Promise<Event> {
  await api.delete(`/events/${eventId}/rsvp`);
  const { data } = await api.get<Event>(`/events/${eventId}`);
  return data;
}
